import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ClienteModel } from 'src/app/models/cliente';
import { Respuesta } from 'src/app/models/respuesta';
import { ResumenCompra } from 'src/app/models/resumen-compra';
import { PagosService } from 'src/app/services/pagos/pagos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-resumen-compra',
  templateUrl: './resumen-compra.component.html',
  styleUrls: ['./resumen-compra.component.scss']
})
export class ResumenCompraComponent implements OnInit, OnDestroy {
  // Codificar base64 btoa();
  // Decodificar base64 atob(); 

  json: string = '';
  jsonFinal: string = '';
  public resumenCompra!: ResumenCompra;
  private respApi!: Respuesta;
  private datosClienteHome!: ClienteModel;
  jsonCliente: string = '';
  jsonFinalCliente: string = '';
  mensajeAlerta: string = '';
  swAlerta: boolean = false;
  minutos: number;
  segundos: number;
  id: any;

  dato1: string = '';
  dato2: string = '';
  dato3: string = '';
  dato4: string = '';
  completo: string[] = [];
  leadId: string = '';
  codAsesor: string = '';
  IdBitacora: string = '';

  constructor(
    private route: ActivatedRoute,
    private pagos: PagosService
  ) {
    this.minutos = 0;
    this.segundos = 8;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosClienteHome = JSON.parse(this.jsonFinal);
      }
    });

    this.llenarCard(this.datosClienteHome);
  }

  ngOnDestroy() {
    if (this.id) {
      clearInterval(this.id);
    }
  }

  llenarCard(dataCliente: ClienteModel): void {
    if (dataCliente !== undefined) {
      this.completo = dataCliente.nombreCliente.split(' ');
      this.dato1 = this.completo[0];
      this.dato2 = this.completo.length > 1 ? this.completo[1] : '';
      this.dato3 = this.completo.length > 2 ? this.completo[2] : '';
      this.dato4 = this.completo.length > 3 ? this.completo[3] : '';

      this.jsonFinal = ' {"Plan": "Plus", "Direccion": "Calle 37 Nº 67-78","Duenio": "'
        + this.dato1.substring(0, 2) + '***** '
        + this.dato2.substring(0, 2) + '***** '
        + this.dato3.substring(0, 2) + '***** '
        + this.dato4.substring(0, 2) + '*****","Identificacion": "'
        + dataCliente.cedulaCliente.toString().substring(0, 2) + '********'
        + dataCliente.cedulaCliente.toString().substring(8, this.datosClienteHome.cedulaCliente.length) +
        '","Ciudad": "Bogotá","Coberturas": [],"FechaContrato": "' + dataCliente.cedulaCliente + '","PagoTotal": "$600.000"}'

      this.resumenCompra = JSON.parse(this.jsonFinal);
    }
    else {
      this.conJsonParam();
    }
  }

  conJsonParam(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const resultado = params.get('json');

      if (resultado === null) {
        this.jsonFinal = ' {"Plan": "Plus", "Direccion": "Calle 37 Nº 67-78","Duenio": "B***** F***** G***Z","Identificacion": "12********41","Ciudad": "Bogotá","Coberturas": [],"FechaContrato": "22/08/2023","PagoTotal": "$600.000"}'
      }
      else {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
      }

      this.resumenCompra = JSON.parse(this.jsonFinal);
    });
  }

  private tick() {
    if (--this.segundos >= 0) {
      this.swAlerta = false;
    }
  }

  pagar(): void {
    this.pagos.getPago().subscribe(
      data => {
        if (data !== null) {
          this.respApi = data;
          window.open('https://pagoslab.suraenlinea.com' + this.respApi.urlPago, "_blank");
        }
        else {
          Swal.fire("La consulta no arrojó datos.", '', 'warning');
        }
      },
      err => {
        this.mensajeAlerta = err.message;
        this.swAlerta = true;
        this.id = setInterval(() => this.tick(), 2000);
      }
    );
  }

}
